<section class="section">
  <p class="description">
    함께 읽는 전자책 플랫폼 북이오<br />
    <b>나눠봐, 너의 남다른 생각</b>
  </p>
  <button class="login-button" (click)="_onLoginButtonClick()">
    로그인하러 가기
  </button>
</section>
